import { render, staticRenderFns } from "./GlobalConfirmationDialog.vue?vue&type=template&id=2a09ae1b&scoped=true"
import script from "./GlobalConfirmationDialog.vue?vue&type=script&lang=ts"
export * from "./GlobalConfirmationDialog.vue?vue&type=script&lang=ts"
import style0 from "./GlobalConfirmationDialog.vue?vue&type=style&index=0&id=2a09ae1b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a09ae1b",
  null
  
)

export default component.exports